var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreyCross = function SvgGreyCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    fillRule: "evenodd",
    d: "M12.496 7.576 5.427.508l-4.65 4.65 7.069 7.068L.87 19.201l4.65 4.65 6.975-6.975 6.88 6.88 4.65-4.65-6.88-6.88 6.974-6.975-4.65-4.65z",
    clipRule: "evenodd"
  })));
};
export { SvgGreyCross as ReactComponent };
export default __webpack_public_path__ + "images/grey-cross.svg";